import React from "react";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import { Customer_InvoiceDropdown } from "data/endpoints";
import DataQuery from "data/DataQuery";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import CustomerState from "infrastructure/store/customer/CustomerState";
import { getRouteParams } from "features/shared/helpers/routeParams";
import { useQuery } from "data/hooks/useQuery";
import InvoiceSimplifiedDTO from "features/invoices/dtos/InvoiceSimplifiedDTO";
import {
  getSelectFieldOptions,
  getSelectFieldOptionKey,
  getTranslatedText,
} from "features/shared/forms/dynamicForm/helpers/dynamicFormHelper";
import { useTranslation } from "react-i18next";
import InvoiceSelect from "features/invoices/components/InvoiceSelect";

const InvoiceSelectField = ({ descriptor, formHandler }: FormFieldProps) => {
  // translations
  const t = useTranslation("shared\\dynamicForms").t;

  // form hook props
  const { bindReactSelectField, errors } = { ...formHandler };

  // store
  const customer = useSelector<IAppState, CustomerState>(
    (store) => store.customer
  ).customer;

  // fetch data
  let invoicesQuery: DataQuery = {
    url: Customer_InvoiceDropdown,
    routeParams: getRouteParams("customerId", customer.customerId!),
    params: descriptor.options?.queryString
      ? new URLSearchParams(descriptor.options?.queryString)
      : undefined,
  };
  const { data: invoices } = useQuery<InvoiceSimplifiedDTO[]>(
    invoicesQuery,
    [],
    [],
    { useTracker: true },
    { apply: true, condition: () => descriptor.options?.source === "fetch" }
  );

  // render
  return (
    <div className={descriptor.className}>
      <InvoiceSelect
        invoices={getSelectFieldOptions(descriptor, invoices)}
        label={getTranslatedText(descriptor, "label", t)}
        placeholder={getTranslatedText(descriptor, "placeholder", t)}
        {...bindReactSelectField(
          descriptor.name,
          getSelectFieldOptionKey(descriptor.options?.optionValue, "invoiceId")
        )}
        errors={errors}
      />
    </div>
  );
};

export default InvoiceSelectField;
